/* север, восток, юг, запад */
/* North, East, South, West */


export const windDirection ={ 
    0: 'north',
    45: 'northeastern',
    90: 'east',
    135: 'southeastern',
    180: 'south',
    225: 'southwestern',
    270: 'west',
    315: 'northwestern',
    360: 'north'
}

export const windPower = {
    0.2:  'stihl',
    1.5:  'calm wind',
    3.3:  'light breeze',
    5.4:  'gentle breeze',
    7.9:  'moderate breeze',
    10.7: 'fresh breeze',
    13.8: 'strong breeze',
    17.1: 'strong breeze'

}